/**
 * HomePlaceholder — temporary landing page for the scaffold slice.
 *
 * Replaced in the home/ feature slice by role-specific dashboard components
 * (AdminHome, AdjusterHome, CustomerHome, TowProviderHome, DriverHome).
 */
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BrandMasthead } from '@/shared';

export default function HomePlaceholder() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: 'center',
          maxWidth: 480,
          width: '100%',
        }}
      >
        <BrandMasthead sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          {t('home.placeholder')}
        </Typography>
        {/* TODO(ui-generator): Remove this placeholder once home/ feature slice lands */}
      </Paper>
    </Box>
  );
}
